<ngx-datatable 
    #tableAtivo
    class='material'                             
    [loadingIndicator]="loadingListaAtivo"
    [columns]="columns" 
    [columnMode]="'force'" 
    [headerHeight]="50"
    [footerHeight]="50"                                                      
    [rowHeight]="'auto'" 
    [rows]='rows'    
    [limit]="paramsCarteira.per_page"
    (sort)="onSort($event)"                
    >

    <ngx-datatable-column name="Data" prop="data_compra"  [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{row.data_compra | date:'dd/MM/yy'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Qtd Dias" 
        prop="qtd_dias" 
         
        [sortable]="false"                                
    >
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{ getQtdDias(row) }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="ATIVO" prop="ativo" [sortable]="true">
        <ng-template  let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span 
                matTooltip="Clique aqui para alterar o valor da cotação atual" 
                style="cursor: pointer; padding: 5px; border-radius: 10px;"
                (click)="alterarCotacao(row.ativo_id)"
                [className]="row.cor_hexadecimal"
            >
                <b>{{row.ativo}}</b>
            </span>                                    
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Quantidade" prop="qtd" [sortable]="true">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span 
                [ngClass]="{'negativo': row.ativo_bloqueado == true}"
                matTooltip="Quantidade Bloqueada" 
                *ngIf="row.ativo_bloqueado == true"
            >
                {{row.qtd | number : '1.0-0'}}
            </span>
            <span 
                [ngClass]="{ 'nao-migrado': row.migrado == false }"
                *ngIf="row.ativo_bloqueado == false"
            >
                {{row.qtd | number : '1.0-0'}} 
            </span>
        </ng-template>
    </ngx-datatable-column>                                            

    <ngx-datatable-column name="Preço Executado" prop="preco_executado" [sortable]="true">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                                                    
        <span [ngClass]="{ 'nao-migrado': row.migrado == false }">
                R$ {{ row.preco_executado | number : '1.2-2'}}
        </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Cotação Atual" prop="cotacao_atual" [sortable]="true">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span [ngClass]="{ 'nao-migrado': row.migrado == false }">
                R$ {{ row.cotacao_atual | number : '1.2-2'}}
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Financeiro (R$)" 
        prop="volume_financerio"         
        [sortable]="true"
    >
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span [ngClass]="{ 'nao-migrado': row.migrado == false }">
                {{getValorFinanceiro(row) | number : '1.2-2'}}
            </span>                                                    
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Vol. Fin. Hoje (R$)" 
        prop="vol_fin_hoje"         
        [sortable]="false"
    >
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span [ngClass]="{ 'nao-migrado': row.migrado == false }">
                {{getCotacaoAtual(row) | number : '1.2-2'}}
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="%" prop="percentual" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span 
                style="display: flex; align-items: center; gap: 5px;"
                *ngIf="row.preco_executado > 0 && row.ativo_tipo != 'OPCAO' " 
                [ngClass]="{
                    'negativo': row.percentual < 0 , 
                    'positivo': row.percentual > 0, 
                    'nao-migrado': row.migrado == false
                }"
            >
                <i class="material-icons negativo" *ngIf="row.percentual < 0">
                    trending_down 
                </i>
                <i class="material-icons positivo" *ngIf="row.percentual > 0">
                    trending_up 
                </i>
                <i class="material-icons positivo" *ngIf="row.percentual == 0">
                    trending_flat 
                </i>

                {{ row.percentual | number : '1.2-2' }} % 
                
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Ações" 
        prop="id" 
        [sortable]="false" 
        
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
    >
        
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            
            <span [ngClass]="{ 'nao-migrado': row.migrado == false }">

                <button 
                    mat-icon-button 
                    matTooltip="Alterar Ativo" 
                    (click)="openAlterarAtivo(row.id)"
                >
                    <mat-icon aria-label="Editar">edit</mat-icon>
                </button>

                <button 
                    mat-icon-button 
                    color="warn" 
                    matTooltip="Excluir Ativo da Carteira" 
                    (click)="delete(row.id)"
                >
                    <mat-icon aria-label="Excluir ativo da carteira">delete</mat-icon>
                </button>

            </span>
            
        </ng-template>

    </ngx-datatable-column>                                           


</ngx-datatable>